import { UserService, MerchantService } from '@/api'
import { getToken, setToken, removeToken, setLoginId, removeLoginId, setMerchantId, getMerchantId, setMerchantNumber, setUserId, setLastLoginTime, setPermissions, setMerchantBasic, setMaskStatus, setFlag } from '@/utils/auth'
// import { resetRouter } from '@/router'
// import store from '@/store'
const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    merchantNumber: '',
    merchantId: '',
    operatorStatus: '',
    merchantIntegrateStep: '',
    errorMsg: '',
    outerStatus: '',
    merchantType: '',
    businessType: '',
    // loginResponse: {
    //   token: '',
    //   loginId: '',
    //   name: '',
    //   // adress: ''
    // }
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_LOGIN_ID: (state, loginId) => {
    state.loginId = loginId
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_MERCHANT_OPERATOR_STATUS: (state, status) => {
    state.operatorStatus = status
  },
  SET_MERCHANT_INTEGRATE_STEP: (state, step) => {
    state.merchantIntegrateStep = step
  },
  SET_MERCHANT_ERRORMSG: (state, errorMsg) => {
    state.errorMsg = errorMsg
  },
  SET_MERCHANT_OUTER_STATUS: (state, status) => {
    state.outerStatus = status
  },
  SET_MERCHANT_TYPE: (state, type) => {
    state.merchantType = type
  },
  SET_BUSINESS_TYPE: (state, type) => {
    state.businessType = type
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { loginId, password } = userInfo
    return new Promise((resolve, reject) => {
      UserService.logIn({ loginId: loginId.trim(), password: password }).then(response => {
        const { data } = response
        if (data.type === 'merchant') {
          commit('SET_TOKEN', data.accessToken)
          commit('SET_LOGIN_ID', data.loginId)
          commit('SET_NAME', data.name)
          setToken(data.accessToken)
          setLoginId(data.loginId)
          setMerchantId(data.merchantId)
          setMerchantNumber(data.merchantNumber)
          setLastLoginTime(data.lastLoginTime)
          setUserId(data.id)
          setMaskStatus(data.maskStatus)
          setFlag(data.flag)
          // setName(data.name)
          if(data.loginId){
            if(data.loginId.indexOf('@')!==-1){
              window.sessionStorage.setItem('registerType','email')
            }else {
              window.sessionStorage.setItem('registerType','phone')
            }
          }

        }
        const permissions = data.permissions.map(_ => {
          _ = '/' + _.replace(/:/g, '/')
          return _
        })
        setPermissions(JSON.stringify(permissions))
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      UserService.logout().then(response => {
        removeToken()
        removeLoginId()
        commit('RESET_STATE')
        resolve(response)
      }).catch((error) => {
        removeToken()
        removeLoginId()
        commit('RESET_STATE')
        reject(error)
      })
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },
  findMerchantBaseInfo({ commit }) {
    return new Promise(resolve => {
      MerchantService.findMerchantBaseInfo({ merchantId: getMerchantId() }).then(res => {
        commit('SET_MERCHANT_OPERATOR_STATUS', res.data.operatorStatus)
        commit('SET_MERCHANT_INTEGRATE_STEP', res.data.merchantIntegrateStep)
        commit('SET_MERCHANT_ERRORMSG', res.data.errorMsg)
        commit('SET_MERCHANT_OUTER_STATUS', res.data.outerStatus)
        commit('SET_MERCHANT_TYPE', res.data.type)
        commit('SET_BUSINESS_TYPE', res.data.businessType)
        commit('SET_NAME', res.data.name)
        setMerchantBasic(res.data)
        resolve(res)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

